import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ExpedientesService } from './../../services/expedientes.service';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-suplido',
  templateUrl: './suplido.component.html',
  styleUrls: ['./suplido.component.css']
})
export class SuplidoComponent implements OnInit {
  @ViewChild("subirArchivo") archivoSubido: ElementRef;
  @ViewChild("mensaje") mensaje:ElementRef;
  suplido={};
  codigo;
  
  archivo;

  constructor(private location:Location, private auth:AuthService, private activatedRoute:ActivatedRoute, 
    private expedientesService:ExpedientesService, private router:Router, private renderer:Renderer2) {

      if(!this.expedientesService.expedienteActivo){
        this.location.back();
      }


      this.activatedRoute.params.subscribe(params=>{
        this.codigo=params["cod"];
      });
  }

  ngOnInit() {
    if(this.codigo=="nuevo"){
      
      this.suplido={};

    }else{
      this.cargarSuplido();
    }
  }

  cargarSuplido(){
    this.expedientesService.getSuplido(this.codigo).
    subscribe(resp=>{
      this.suplido=resp["suplido"];
      this.suplido["ESfecha"]=this.suplido["ESfecha"].substring(0,10);
    });
  }

  guardarSuplido(){
    if(this.codigo=="nuevo"){
      this.insertSuplido();
    }else{
      this.updateSuplido();
    }
  }

  insertSuplido(){
    this.expedientesService.insertSuplido(this.suplido, this.archivoSubido.nativeElement.files[0])
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);

      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }

      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 2000);
    });
  }

  updateSuplido(){
    this.expedientesService.updateSuplido(this.suplido,this.codigo)
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);

      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }

      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 2000);
    });
  }

  parseDate(dateString: string){
    if (dateString) {
      let fecha=new Date(dateString);
      var myDate_string = fecha.toISOString();
      var myDate_string = myDate_string.replace("T"," ");
      var myDate_string = myDate_string.substring(0,10);
      return myDate_string;
    } else {
      return null;
    }
  }

  volver(){
    this.location.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/suplido/suplido.component.ts